"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const render_1 = __importDefault(require("./render"));
const Html = (props) => {
    return react_1.useMemo(() => react_1.default.createElement(react_1.default.Fragment, null, render_1.default(props.children, props)), [
        props.collapse,
        ...Object.values(props.renderers || {}),
        ...(Array.isArray(props.style) ? props.style : [props.style]),
        ...(Array.isArray(props.stylesheet)
            ? props.stylesheet
            : [props.stylesheet]),
        props.resetStyles,
        props.children,
    ]);
};
exports.default = Html;
//# sourceMappingURL=Html.js.map